<template>
  <div v-loading="loading">
    <div class=' content'>
      <div class="s_wrapper">
        <!-- <el-input class="s_input" placeholder="请输入门店名称" suffix-icon="el-icon-search" v-model="storeName" clearable
          @change="onSearch"></el-input> -->
        <el-input class="s_input" placeholder="请输入项目名称" suffix-icon="el-icon-search" v-model="projectName" clearable
          @change="onSearch"></el-input>
        <el-input class="s_input" placeholder="请输入订单编号" suffix-icon="el-icon-search" v-model="orderCode" clearable
          @change="onSearch"></el-input>
        <el-select class="s_input" v-model="payType" placeholder="请选择付款方式" clearable @change="onSearch">
          <el-option v-for="item in payTypeArr" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
        <el-select class="s_input" v-model="orderType" placeholder="请选择订单类型" clearable @change="onSearch">
          <el-option v-for="item in orderTypeArr" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
        <!-- <el-select class="s_input" v-model="reservationType" placeholder="请选择预约状态" clearable @change="onSearch">
          <el-option v-for="item in reservationTypeArr" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select> -->
        <el-date-picker v-model="formInline.time" @change="gettime" type="daterange" range-separator="至"
          start-placeholder="开始日期" end-placeholder="结束日期"
          style="border-radius: 10px;  margin-left: 20px; border: 1px solid #ccc" value-format="yyyy-MM-dd">
        </el-date-picker>
      </div>
      <!-- tab栏 -->
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="全部订单" name="null"></el-tab-pane>
        <el-tab-pane label="待支付" name="0"></el-tab-pane>
        <el-tab-pane label="已支付" name="1"></el-tab-pane>
        <el-tab-pane label="已完成" name="2"></el-tab-pane>
        <el-tab-pane label="已取消" name="3"></el-tab-pane>
      </el-tabs>
      <!-- 表格 -->
      <div class="g_table ">
        <el-table max-height="540" :data="tableData">
          <el-table-column label="序号" min-width="60" align="center">
            <template slot-scope="scope">
              {{ scope.$index + 1 + (currentPage - 1) * pageSize }}
            </template>
          </el-table-column>
          <!-- <el-table-column prop="storeName" label="门店名称" show-overflow-tooltip min-width="150" align="center">
          </el-table-column> -->
          <el-table-column prop="projectName" label="项目名称" show-overflow-tooltip min-width="180" align="center">
          </el-table-column>
          <el-table-column prop="orderCode" label="订单编号" show-overflow-tooltip min-width="180" align="center">
          </el-table-column>
          <el-table-column prop="orderType" label="订单类型" show-overflow-tooltip min-width="100" align="center">
            <template slot-scope="scope">
              <div v-if="scope.row.orderType == 1">线上订单</div>
              <div v-if="scope.row.orderType == 2">线下订单</div>
            </template>
          </el-table-column>
          <el-table-column prop="payType" label="付款方式" show-overflow-tooltip min-width="100" align="center">
            <template slot-scope="scope">
              <div v-if="scope.row.payType == 1">线上支付</div>
              <div v-if="scope.row.payType == 2">现金支付</div>
              <div v-if="scope.row.payType == 3">会员卡支付</div>
            </template>
          </el-table-column>
          <el-table-column prop="orderTime" label="下单时间" min-width="180" align="center">
          </el-table-column>
          <el-table-column label="付款时间" min-width="180" align="center">
            <template slot-scope="scope">
              <div>{{ scope.row.paymentTime || '--' }}</div>
            </template>
          </el-table-column>
          <!-- <el-table-column label="预约时间" min-width="180" align="center">
            <template slot-scope="scope">
              <div>{{ scope.row.reservationTime || '--' }}</div>
            </template>
          </el-table-column> -->
          <el-table-column prop="userCode" label="用户编号" show-overflow-tooltip min-width="120" align="center">
          </el-table-column>
          <el-table-column label="订单金额" min-width="180" align="center">
            <template slot-scope="scope">
              <div>{{ `￥${scope.row.orderAmount}` }}</div>
            </template>
          </el-table-column>
          <el-table-column label="支付金额" min-width="180" align="center">
            <template slot-scope="scope">
              <div>{{ `￥${scope.row.payAmount}` }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="orderStatus" label="订单状态" show-overflow-tooltip min-width="100" align="center">
            <template slot-scope="scope">
              <div v-if="scope.row.orderStatus == 0" style="color: red;">待支付</div>
              <div v-if="scope.row.orderStatus == 1">已支付</div>
              <div v-if="scope.row.orderStatus == 2">已完成</div>
              <div v-if="scope.row.orderStatus == 3">已取消</div>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="reservationType" label="预约状态" show-overflow-tooltip min-width="100" align="center">
            <template slot-scope="scope">
              <div v-if="scope.row.reservationType == 1" style="color: red;">待预约</div>
              <div v-if="scope.row.reservationType == 2">待核销</div>
              <div v-if="scope.row.reservationType == 3">已完成</div>
              <div v-if="scope.row.reservationType == null || scope.row.reservationType == -1">--</div>
            </template>
          </el-table-column> -->
          <el-table-column label="操作" min-width="150" align="center" fixed="right">
            <template slot-scope="scope">
              <el-button type="primary" size="small" plain @click="handleCommand(scope.row)">查看订单</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!-- 分页 -->
    <div class="pagination">
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page.sync="currentPage" :page-size="pageSize" :page-sizes="pageSizeArr"
        layout="prev, pager, next, jumper, sizes, total" :total="totalCount">
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      // 表格数据
      tableData: [],
      // 分页器
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页显示的行数
      pageSizeArr: [10, 20, 50],
      totalCount: 0, // 总记录数据
      startTime: '',//开始时间
      endTime: '',//结束时间
      formInline: {
        time: []
      },//日期区间
      activeName: 'null',
      // 订单类型
      orderTypeArr: [
        {
          value: '1',
          label: '线上订单'
        }, {
          value: '2',
          label: '线下订单'
        },
      ],
      payTypeArr: [
        {
          value: '1',
          label: '线上支付'
        }, {
          value: '2',
          label: '现金支付'
        }, {
          value: '3',
          label: '会员卡支付'
        },
      ],
      // reservationTypeArr: [
      //   {
      //     value: '1',
      //     label: '待预约'
      //   }, {
      //     value: '2',
      //     label: '待核销'
      //   }, {
      //     value: '3',
      //     label: '已完成'
      //   },
      // ],
      orderType: '',//订单类型
      payType: '',//支付类型
      // reservationType: '',//预约状态
      orderCode: '',//订单编号
      storeName: '',//门店名称
      projectName: '',//项目名称
    }
  },
  created() {
    this.getRequest()//请求数据
  },
  methods: {
    handleClick(tab) {
      const { name } = tab
      if (name == "null") {
        this.orderStatus = ''
      } else {
        this.orderStatus = name
      }
      this.getRequest()
    },
    // 请求
    getRequest() {
      this.loading = true;
      this.$axios.get(this.$api.projectOrderList, {
        params: {
          projectType: 1,//项目类型:1.正式项目,2.体验项目 ,3套餐项目
          orderType: this.orderType || null,//订单类型:1.线上订单,2.线下订单
          payType: this.payType || null,//支付类型:1.线上支付,2.现金支付
          orderCode: this.orderCode || null,//订单编号
          projectName: this.projectName || null,//项目名称
          storeName: this.storeName || null,//门店名称
          orderStatus: this.orderStatus == 'null' ? '' : this.orderStatus,//订单状态
          startTime: this.startTime || null,//开始时间
          endTime: this.endTime || null,//结束时间
          page: this.currentPage,
          pageSize: this.pageSize,
        }
      }).then((res) => {
        const { code, result } = res
        if (code == 100) {
          this.totalCount = result.totalCount
          this.tableData = result.list || []
          this.loading = false;
        }
      }).catch((err) => {
        this.$message.error(err.desc)
        this.loading = false;
      })

    },
    // 时间区间搜索
    gettime() {
      this.startTime = this.formInline.time ? this.formInline.time[0] || "" : "";
      this.endTime = this.formInline.time ? this.formInline.time[1] || "" : "";
      this.getRequest()
    },
    handleCommand(row) {
      this.$router.push({ name: 'projectOrderDet', query: { projectOrderId: row.projectOrderId } })
    },
    // 清空
    clearData() {
      this.tableData = [];
      this.currentPage = 1;
    },
    // 搜索
    onSearch() {
      this.clearData();
      this.getRequest();
    },
    handleSizeChange(e) {
      this.pageSize = e
      this.getRequest()
    },
    handleCurrentChange(e) {
      this.tableData = []
      this.currentPage = e
      this.getRequest()
    },

  },
}
</script>

<style scoped lang='scss'>
.content {


  .el-date-editor {
    margin-left: 10px !important;
  }

  .header-btn {
    margin-left: 10px;
  }
}


// 操作下拉框内容
.el-dropdown-link {
  cursor: pointer;
}

.el-icon-arrow-down {
  font-size: 12px;
}

.el-date-editor,
.el-range-editor,
.el-input__inner,
.el-date-editor--daterange {
  margin-left: 0px !important;
}

.el-date-editor--daterange.el-input__inner,
.el-date-editor--timerange.el-input,
.el-date-editor--timerange.el-input__inner {
  width: 250px;
}
</style>
